import * as Sentry from "@sentry/browser"
import type { Config } from "@ironzion/frontend-js-config"

/**
 * Setup an onLoad event for our FE Sentry SDK
 */
export const configureSentry = (constants: Config) => {
  if (constants.sentryDsn) {
    Sentry.init({
      dsn: constants.sentryDsn,
      release: constants.sentryRelease,
      tracesSampleRate: 0.5,
      environment: constants.stage,
      normalizeDepth: 30,
      integrations: [
        new Sentry.BrowserTracing({
          tracePropagationTargets: [constants.apiUrl],
          shouldCreateSpanForRequest: (url) => !url.match(/(googleads)|(\S+\.(js|css))/),
          enableInp: true,
        }),
      ],
      ignoreErrors: [
        "TypeError",
        "ChunkLoadError",
        "chrome-extension",
        "safari-web-extension",
        "iframe",
        "API returned an exception: PermissionDeniedException",
        RegExp(/API returned an exception:.*Attempted to load a session for an inactive user/),
        "This email is not valid:",
        "ResizeObserver loop limit exceeded",
        RegExp(/Non-Error promise rejection captured.*/),
        "Event `Event` (type=error) captured as promise rejection",
        RegExp(/The user aborted a request/),
        RegExp(/Session has already been logged out/),
        RegExp(/IntegrationError/),
      ],
    })
  }
}
